import { MessageCircle, ArrowRight } from "lucide-react";
import { BRAND } from "@/lib/brand";

export const CTASection = () => {
  return (
    <section
      id="cta"
      data-testid="cta-section"
      className="relative py-24 lg:py-28 bg-white"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="relative rounded-3xl overflow-hidden bg-navy p-10 md:p-16 lg:p-20 grain">
          <div
            className="absolute -top-24 -left-24 w-[420px] h-[420px] rounded-full blur-3xl opacity-40"
            style={{ background: "radial-gradient(closest-side, rgba(184,134,58,0.6), transparent)" }}
            aria-hidden
          />
          <div
            className="absolute -bottom-32 -right-32 w-[520px] h-[520px] rounded-full blur-3xl opacity-30"
            style={{ background: "radial-gradient(closest-side, rgba(59,130,246,0.5), transparent)" }}
            aria-hidden
          />

          <div className="relative grid lg:grid-cols-12 gap-10 items-center">
            <div className="lg:col-span-8">
              <div className="tracking-eyebrow text-gold mb-5">Sua próxima peça começa aqui</div>
              <h2
                className="font-display text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-[1] tracking-[-0.03em]"
                data-testid="cta-title"
              >
                Fale com um especialista.
                <br />
                <span className="text-white/70">Sua operação agradece.</span>
              </h2>
              <p className="mt-6 text-lg text-white/70 max-w-2xl leading-relaxed">
                Envie sua demanda pelo WhatsApp. Cotação em até 24h úteis, com sourcing global,
                rastreabilidade e logística priorizada.
              </p>
            </div>
            <div className="lg:col-span-4 flex flex-col gap-3 lg:items-end">
              <a
                href={BRAND.whatsappLink}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="cta-primary-btn"
                className="btn-primary text-base"
              >
                <MessageCircle className="w-5 h-5" />
                Solicitar Cotação
                <ArrowRight className="w-4 h-4" />
              </a>
              <a
                href="#contato"
                data-testid="cta-secondary-btn"
                className="btn-ghost text-base"
              >
                Ver contatos
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
